module.exports = __webpack_public_path__ + "img/left-clench.136ca3e3.png";